import React, { type ReactNode } from 'react';
import Header from '../Header';

type LayoutProps = {
	readonly children?: ReactNode;
};

export default function Layout({ children }: LayoutProps): React.ReactElement {
	return (
		<div className="o-wrapper">
			<div className="o-layout">
				<Header />
				<main className="o-layout__main">
					<div className="o-wrapper">{children}</div>
				</main>
			</div>
		</div>
	);
}
